import { IncomingInvoiceActionType } from "models/actionTypes/incomingInvoiceActionTypes";
import { IncomingInvoicePermissions } from "models/propTypes/incomingInvoicePropTypes";
import { ReduxConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const incomingInvoiceCreated = (invoice: WintSuperkollAPIModel.IncomingInvoice): IncomingInvoiceActionType => {
  return {
    type: ReduxConstants.IncomingInvoiceActions.INCOMING_INVOICE_CREATED,
    payload: invoice,
  };
};

export const incomingInvoiceUpdated = (
  invoice: WintSuperkollAPIModel.IncomingInvoice,
  loggedInUserId: number,
  permissions: IncomingInvoicePermissions
): IncomingInvoiceActionType => {
  return {
    type: ReduxConstants.IncomingInvoiceActions.INCOMING_INVOICE_UPDATED,
    payload: { invoice, loggedInUserId: loggedInUserId, permissions },
  };
};

export const incomingInvoiceUpdatedContent = (
  invoice: WintSuperkollAPIModel.IncomingInvoice
): IncomingInvoiceActionType => {
  return {
    type: ReduxConstants.IncomingInvoiceActions.INCOMING_INVOICE_UPDATED_CONTENT,
    payload: invoice,
  };
};

export const incomingInvoiceAccepted = (invoiceId: number): IncomingInvoiceActionType => {
  return {
    type: ReduxConstants.IncomingInvoiceActions.INCOMING_INVOICE_ACCEPTED,
    payload: invoiceId,
  };
};

export const incomingInvoiceForwarded = (invoiceId: number): IncomingInvoiceActionType => {
  return {
    type: ReduxConstants.IncomingInvoiceActions.INCOMING_INVOICE_FORWARDED,
    payload: invoiceId,
  };
};

export const incomingInvoiceSentBack = (invoiceId: number): IncomingInvoiceActionType => {
  return {
    type: ReduxConstants.IncomingInvoiceActions.INCOMING_INVOICE_SENT_BACK,
    payload: invoiceId,
  };
};

export const incomingInvoiceConverted = (invoiceId: number): IncomingInvoiceActionType => {
  return {
    type: ReduxConstants.IncomingInvoiceActions.INCOMING_INVOICE_CONVERTED,
    payload: invoiceId,
  };
};

export const incomingInvoiceCancelled = (invoiceId: number): IncomingInvoiceActionType => {
  return {
    type: ReduxConstants.IncomingInvoiceActions.INCOMING_INVOICE_CANCELLED,
    payload: invoiceId,
  };
};

export const incomingInvoiceSnoozed = (invoiceId: number): IncomingInvoiceActionType => {
  return {
    type: ReduxConstants.IncomingInvoiceActions.INCOMING_INVOICE_SNOOZED,
    payload: invoiceId,
  };
};

export const agingIncomingInvoiceSnoozed = (invoiceId: number): IncomingInvoiceActionType => {
  return {
    type: ReduxConstants.IncomingInvoiceActions.AGING_INCOMING_INVOICE_SNOOZED,
    payload: invoiceId,
  };
};

export const agingIncomingInvoiceSubmitted = (invoiceId: number): IncomingInvoiceActionType => {
  return {
    type: ReduxConstants.IncomingInvoiceActions.AGING_INCOMING_INVOICE_SUBMITTED,
    payload: invoiceId,
  };
};
